export const isInventory = state => state.storePresentationConfig?.store_type == 'inventory';